import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
// const { SearchBar } = Search;
import { toast } from "react-toastify";

import { Row, Col } from "react-bootstrap";

//Import form
import FormUpload from "./FormUpload";

import { PDFDownloadLink } from "@react-pdf/renderer";
import FarmerDocumenttemp from "../../views/PrintPdf/FarmerDocumenttemp";

// Import Service
import RegsugarService from "../../services/regsugar.service";
import TimeregService from "../../services/timereg.service";
import UserService from "../../services/user.service";
import authService from "../../services/auth.service";

// Import Modal
import Modaladdsugarcane from "./Modaladdsugarcane";
import ModalAddDetail from "./ModalAddDetail";
import ModalEditDetail from "./ModalEditDetail";
import ModalViewApprove from "../ApproveRegister/ModalViewApprove";

//Import PDFDownload
import DownloadPDF from "./DownloadPdf";

// import moment from "moment/min/moment-with-locales";
import moment from "moment";
import "moment/locale/th";
moment.locale("th");

// moment.defineLocale("th-foo", {
//   parentLocale: "th",
//   /* */
// });
// moment.updateLocale("th", null);

//Import Loading
import Spinner from "react-bootstrap/Spinner";
// import LoadingAlert from "../../components/LoadingAlert";
import { Modal } from "react-bootstrap";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

// Import CSS
import "./regsugarcane.css";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

const renderTooltipUpload = (props) => (
  <Tooltip {...props}>อัพโหลดไฟล์เพิ่มเติม</Tooltip>
);
const renderTooltipEdit = (props) => (
  <Tooltip {...props}>แก้ไขข้อมูลการจดทะเบียน</Tooltip>
);
const renderTooltipDelete = (props) => (
  <Tooltip {...props}>ลบการจดทะเบียน</Tooltip>
);
const renderTooltipPrint = (props) => (
  <Tooltip {...props}>พิมพ์บัตรชั่วคราว</Tooltip>
);

function Regsugarcanelist() {
  const [loadingPage, setLoadingPage] = useState(true);
  // const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [show_add, setShow_add] = useState(false);
  const [disableAdd, setDisableAdd] = useState(true);
  const [show_addDetail, setShow_addDetail] = useState(false);
  const [farmer_idcard, setFarmer_idcard] = useState(0);
  const [academy, setAcademy] = useState([]);
  const [data_select, setData_select] = useState({ timereg_id: 0 });
  const [showUploadForm, setShowUploadForm] = useState(false);
  const [selectRegid, setSelectRegid] = useState(0);
  const [showEdit, setShowEdit] = useState(false);
  const [currentTimeReg, setCurrentTimeReg] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [printSelect, setPrintSelect] = useState({});
  const [current_timereg_id, setCurrent_timereg_id] = useState(0);

  const [farmerselectView, farmerSetselectView] = useState({});
  const [showView, setShowView] = useState(false);

  const [isDisabled, setIsDisabled] = useState(false);
  const daystop = 10;

  useEffect(() => {
    TimeregService.getLastCurrent().then((res) => {
      const stop = res.data?.data?.timereg_stop;
      if (!stop) {
        setIsDisabled(true); // ถ้าไม่มีข้อมูล ปิดปุ่มเลย
        return;
      }

      const stopDate = new Date(stop);
      const expireDate = new Date(stopDate);
      expireDate.setDate(stopDate.getDate() + daystop);

      const now = new Date();
      setIsDisabled(now > expireDate);
    });
  }, []);

  // const [timeregList, setTimeregList] = useState([]);
  // const [timeregSelect, setTimeregSelect] = useState(0);

  const user = authService.getCurrentUser();

  // const handleTimeregChange = (e) => {
  //   setTimeregSelect(e.target.value);
  //   getData(user.user.user_reg, e.target.value);
  // };
  // const getTimeRegList = () => {
  //   TimeregService.getTimereglist(user.user.user_reg)
  //     .then((response) => {
  //       setTimeregList(response.data.data);
  //     })
  //     .catch((err) => {
  //       console.log("fetch timereg List Error :" + err);
  //     });
  // };
  const clickViewApprove = (row) => {
    farmerSetselectView({
      regsugar_id: row.regsugar_id,
      person_card_id: row.person_card_id,
      approve_status: row.approve_status,
    });
    setShowView(true);
  };

  const checkTimereg = () => {
    TimeregService.getLastCurrent()
      .then((response) => {
        if (response.data.success && response.data.data) {
          setData_select({
            ...data_select,
            timereg_id: response.data.data.timereg_id,
          });
          setCurrentTimeReg(response.data.data);
          getData(user.user.user_reg, response.data.data.timereg_id);
          // setDisableAdd(false);
        } else {
          setCurrentTimeReg({ message: "ยังไม่มีรอบจดทะเบียน" });
        }
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
      })
      .finally(() => setLoadingPage(false));

    TimeregService.getCurrent()
      .then((response) => {
        if (response.data.success && response.data.data) {
          setDisableAdd(false);
          setCurrent_timereg_id(response.data.data.timereg_id);
          // setData_select({
          //   ...data_select,
          //   timereg_id: response.data.data.timereg_id,
          // });
          // setCurrentTimeReg(response.data.data);
          // getData(user.user.user_reg, response.data.data.timereg_id);
        } else {
          setDisableAdd(true);
          setCurrent_timereg_id(0);

          // setCurrentTimeReg({ message: "ไม่มีรอบให้จดทะเบียน" });
        }
      })
      .catch((error) => {
        toast.error("error fetching data: ", error);
      })
      .finally(() => setLoadingPage(false));
  };
  const getAcademy = () => {
    UserService.getAcademylist()
      .then((response) => {
        setAcademy(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching getAcademy: ", error);
      });
  };

  useEffect(() => {
    checkTimereg();
    getAcademy();
  }, []);

  const getData = (user_reg, timereg_id) => {
    RegsugarService.getRegsugarlist(user_reg, timereg_id)
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoadingPage(false);
      });
  };

  const clickDelete = (row) => {
    confirmAlert({
      title: "",
      message: "ต้องการลบ " + row.farmer_name,
      buttons: [
        {
          label: "ใช่",
          onClick: () => {
            RegsugarService.deleteRegsugar(row.regsugar_id)
              .then((response) => {
                if (response.data.success) {
                  // setShow_delete(false);
                  // alert(response.data.message);
                  var newArray = data.filter(
                    (a) => a.regsugar_id != row.regsugar_id
                  );
                  setData(newArray);
                } else {
                  toast.error(response.data.message);
                }
              })
              .catch((error) => {
                toast.error("error delete", error);
              });
          },
        },
        {
          label: "ไม่ใช่",
          onClick: () => false,
        },
      ],
      overlayClassName: "confirm-alert-default",
    });
  };
  const clickUpload = (row) => {
    setSelectRegid(row.regsugar_id);
    setShowUploadForm(true);
  };
  const clickEdit = async (row) => {
    setData_select({
      ...data_select,
      ...row,
    });
    setShowEdit(true);
  };
  const clickPrintPDF = (row) => {
    setShowAlert(true);
    setPrintSelect(row.row);
  };
  const PrintPDF = (props) => {
    const handleClose = () => props.set_show(false);
    return (
      <>
        <Modal show={props.show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>PrintPdf</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <PDFDownloadLink
              document={
                <FarmerDocumenttemp regsugar_id={props.row.regsugar_id} />
              }
              fileName={
                "บัตรชาวไร่อ้อยชั่วคราว-" + props.row.farmer_name + ".pdf"
              }
            >
              {({ blob, url, loading, error }) => {
                console.log(blob, url, error);
                return loading ? (
                  "..."
                ) : (
                  <i
                    className="fa fa-print custom-icon-table"
                    style={{ color: "green" }}
                  >
                    {" " + props.row.farmer_name}
                  </i>
                );
              }}
            </PDFDownloadLink>
          </Modal.Body>
        </Modal>
      </>
    );
  };
  PrintPDF.propTypes = {
    show: PropTypes.bool,
    set_show: PropTypes.func,
    row: PropTypes.object,
  };
  const ActionsEdit = (row) => {
    if (
      row.row.approve_status == "อนุมัติ" ||
      row.row.approve_status == "ไม่อนุมัติ"
    ) {
      return (
        <>
          <i
            className="bi bi-search custom-icon-table"
            onClick={() => clickViewApprove(row.row)}
          ></i>
          {row.row.farmer_card_id != "-" ? (
            <DownloadPDF
              card={row.row.farmer_card_id}
              idno={row.row.person_card_id}
            />
          ) : (
            ""
          )}
        </>
      );
    } else {
      return (
        <>
          <div hidden={isDisabled}>
            <OverlayTrigger placement="top" overlay={renderTooltipEdit}>
              <i
                className="bi bi-pencil custom-icon-table"
                onClick={() => clickEdit(row.row)}
              ></i>
            </OverlayTrigger>

            <OverlayTrigger placement="top" overlay={renderTooltipUpload}>
              <i
                className="bi bi-upload custom-icon-table"
                style={{ color: "green" }}
                onClick={() => clickUpload(row.row)}
              ></i>
            </OverlayTrigger>
            <OverlayTrigger placement="top" overlay={renderTooltipDelete}>
              <i
                className="bi bi-trash custom-icon-table"
                style={{ color: "red" }}
                onClick={() => clickDelete(row.row)}
              ></i>
            </OverlayTrigger>
          </div>

          <OverlayTrigger placement="top" overlay={renderTooltipPrint}>
            <i
              className="fa fa-print custom-icon-table"
              style={{ color: "green" }}
              onClick={() => clickPrintPDF(row)}
            ></i>
          </OverlayTrigger>
        </>
      );
    }
  };

  const actionsEdittFormatter = (cell, row) => {
    return <ActionsEdit row={row} />;
  };

  const columns = [
    {
      text: "regsugar_id",
      dataField: "regsugar_id",
      sort: true,
      // filter: textFilter({ placeholder: "ค้นหา" }),
      hidden: true,
    },
    {
      text: "ชื่อ-สกุล",
      dataField: "farmer_name",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "เลขบัตรประชาชน",
      dataField: "person_card_id",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "5%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "สร้างโดย",
      dataField: "user_create",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },

    {
      text: "ผลการพิจารณา",
      dataField: "approve_status",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "อนุมัติโดย",
      dataField: "approver_name",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    // {
    //   text: "เลขชาวไร่",
    //   dataField: "farmer_card_id",
    //   sort: true,
    //   editable: false,
    //   filter: textFilter({ placeholder: "ค้นหา" }),
    //   searchable: false,
    //   headerStyle: () => {
    //     return { textAlign: "center", width: "10%" };
    //   },
    //   style: {
    //     // wordBreak: "break-word",
    //     textAlign: "center",
    //   },
    // },
    {
      text: "เริ่ม",
      dataField: "start_date",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      formatter: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell)).add(543, "year").format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell)).add(543, "year").format("ll");
        } else {
          return cell;
        }
      },
      searchable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      text: "สิ้นสุด",
      dataField: "end_date",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      searchable: false,
      formatter: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell))
            .add(543, "year")
            .locale("th")
            .format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell))
            .add(543, "year")
            .locale("th")
            .format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      text: "หมายเหตุ",
      dataField: "comment",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      text: "ดำเนินการ",
      dataField: "edit",
      isDummyField: true,
      editable: false,
      formatter: actionsEdittFormatter,
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
    },
  ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    firstPageText: "|<",
    lastPageText: ">|",
    nextPageText: ">>",
    prePageText: "<<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
  });

  const handleClickAdd = () => {
    setShow_add(true);
  };

  const handleFarmerIdcard = (farmer_idcard) => {
    setFarmer_idcard(farmer_idcard);
  };

  const handleFaremerIdSelect = (a) =>
    setData_select({ ...data_select, farmer_id: a });

  if (loadingPage) return <Spinner animation="border" variant="primary" />;
  if (error) return `Error :${error}`;

  return (
    <div>
      {/* {loading ? <LoadingAlert /> : ""} */}
      <PrintPDF row={printSelect} show={showAlert} set_show={setShowAlert} />
      <ModalViewApprove
        show={showView}
        hidden={setShowView}
        farmerselect={farmerselectView}
        setdata={setData}
      />
      <FormUpload
        show={showUploadForm}
        hidden_func={(a) => {
          setShowUploadForm(a);
        }}
        regid={selectRegid}
      />
      <ModalEditDetail
        show={showEdit}
        hidden_func={(a) => setShowEdit(a)}
        setdata={setData}
        data={data}
        academy={academy}
        selectdata={data_select}
        timereg_id={current_timereg_id}
      />

      <ModalAddDetail
        show={show_addDetail}
        hidden={(a) => setShow_addDetail(a)}
        setdata={setData}
        data={data}
        farmer_idcard={farmer_idcard}
        academy={academy}
        selectdata={data_select}
      />
      <Modaladdsugarcane
        show={show_add}
        hidden={(a) => setShow_add(a)}
        data={data}
        setdata={(a) => setData(a)}
        setShowAddDetail={(a) => setShow_addDetail(a)}
        selectFarmerIdcard={handleFarmerIdcard}
        setFarmerid={handleFaremerIdSelect}
        timereg_id={current_timereg_id}
      />

      <ToolkitProvider
        bootstrap4
        keyField="regsugar_id"
        data={data}
        columns={columns}
        search
      >
        {(prop) => (
          <React.Fragment>
            <Row>
              <Col md={2}>
                <button
                  className={disableAdd ? "btn btn-warning" : "btn btn-primary"}
                  onClick={handleClickAdd}
                  style={{
                    padding: ".375rem .75rem",
                    fontSize: "1rem",
                    marginRight: "1rem",
                  }}
                  disabled={disableAdd}
                >
                  จดทะเบียน
                </button>
                {/* <SearchBar {...prop.searchProps} /> */}
              </Col>
              <Col md={10}>
                <div
                  className={disableAdd ? "invalid-register" : "valid-register"}
                >
                  {disableAdd && !currentTimeReg.message ? (
                    <>
                      <span>สิ้นสุดการจดทะเบียน : </span>
                    </>
                  ) : (
                    ""
                  )}
                  {currentTimeReg.message ? (
                    <>
                      <span>{currentTimeReg.message}</span>
                    </>
                  ) : (
                    <>
                      <span style={{ fontWeight: "bold" }}>
                        {currentTimeReg.timereg_desc}
                      </span>
                      <span>{" เริ่มวันที่ "}</span>
                      <span>
                        {moment(currentTimeReg.timereg_start)
                          .add(543, "year")
                          .locale("th")
                          .format("ll")}
                      </span>
                      <span>{" ถึงวันที่ "}</span>
                      <span>
                        {moment(currentTimeReg.timereg_stop)
                          .add(543, "year")
                          .locale("th")
                          .format("ll")}
                      </span>
                    </>
                  )}
                </div>
              </Col>
            </Row>
            <hr />
            <BootstrapTable
              pagination={pagination}
              {...prop.baseProps}
              filter={filterFactory()}
            />
          </React.Fragment>
        )}
      </ToolkitProvider>
    </div>
  );
}

export default Regsugarcanelist;
